import * as Types from '../types/types.generated';

import { useQuery, useMutation, UseQueryOptions, UseMutationOptions } from '@tanstack/react-query';
import { useGraphqlFetcher } from '../hooks/useGraphqlFetcher';


export const SenetGetAccountMetricsReportDocument = `
    query senetGetAccountMetricsReport {
  getAccountMetricsReport {
    reports {
      reportId
      createdDate
      portalUserGUID
      parameters {
        dateGenerated
        totalClients
        activeClientsWithUsers
        inactiveClients
        activeClientsWithoutUsers
        totalUsers
        activeUsers
        unregisteredUsers
        pendingUsers
        activeClientsWithoutActiveUsers
      }
    }
  }
}
    `;

export const useSenetGetAccountMetricsReportQuery = <
      TData = Types.ISenetGetAccountMetricsReportQuery,
      TError = Types.IGqlError[]
    >(
      variables?: Types.ISenetGetAccountMetricsReportQueryVariables,
      options?: Omit<UseQueryOptions<Types.ISenetGetAccountMetricsReportQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<Types.ISenetGetAccountMetricsReportQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<Types.ISenetGetAccountMetricsReportQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['senetGetAccountMetricsReport'] : ['senetGetAccountMetricsReport', variables],
    queryFn: useGraphqlFetcher<Types.ISenetGetAccountMetricsReportQuery, Types.ISenetGetAccountMetricsReportQueryVariables>(SenetGetAccountMetricsReportDocument).bind(null, variables),
    ...options
  }
    )};

export const SenetGetSourceSystemReportDocument = `
    query senetGetSourceSystemReport {
  getSourceSystemReport {
    reports {
      orgCount
      queryKeyCount
      sourceSystem
    }
  }
}
    `;

export const useSenetGetSourceSystemReportQuery = <
      TData = Types.ISenetGetSourceSystemReportQuery,
      TError = Types.IGqlError[]
    >(
      variables?: Types.ISenetGetSourceSystemReportQueryVariables,
      options?: Omit<UseQueryOptions<Types.ISenetGetSourceSystemReportQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<Types.ISenetGetSourceSystemReportQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<Types.ISenetGetSourceSystemReportQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['senetGetSourceSystemReport'] : ['senetGetSourceSystemReport', variables],
    queryFn: useGraphqlFetcher<Types.ISenetGetSourceSystemReportQuery, Types.ISenetGetSourceSystemReportQueryVariables>(SenetGetSourceSystemReportDocument).bind(null, variables),
    ...options
  }
    )};

export const SenetPutAccountMetricsReportDocument = `
    mutation senetPutAccountMetricsReport {
  putAccountMetricsReport {
    createdDate
    parameters {
      dateGenerated
      totalClients
      activeClientsWithUsers
      inactiveClients
      activeClientsWithoutUsers
      totalUsers
      activeUsers
      unregisteredUsers
      pendingUsers
      activeClientsWithoutActiveUsers
    }
    portalUserGUID
    reportId
  }
}
    `;

export const useSenetPutAccountMetricsReportMutation = <
      TError = Types.IGqlError[],
      TContext = unknown
    >(options?: UseMutationOptions<Types.ISenetPutAccountMetricsReportMutation, TError, Types.ISenetPutAccountMetricsReportMutationVariables, TContext>) => {
    
    return useMutation<Types.ISenetPutAccountMetricsReportMutation, TError, Types.ISenetPutAccountMetricsReportMutationVariables, TContext>(
      {
    mutationKey: ['senetPutAccountMetricsReport'],
    mutationFn: useGraphqlFetcher<Types.ISenetPutAccountMetricsReportMutation, Types.ISenetPutAccountMetricsReportMutationVariables>(SenetPutAccountMetricsReportDocument),
    ...options
  }
    )};

export const GetEventLogPrefetchDocument = `
    query getEventLogPrefetch($date: String, $userFullName: String, $userEmail: String, $organizationName: String, $eventType: String, $eventName: String, $eventMessage: String, $eventStatus: String) {
  getEventLogPrefetch(
    date: $date
    userFullName: $userFullName
    userEmail: $userEmail
    organizationName: $organizationName
    eventType: $eventType
    eventName: $eventName
    eventMessage: $eventMessage
    eventStatus: $eventStatus
  ) {
    userEmails
    userFullNames
    organizationNames
    types
    statuses
    recordCount
  }
}
    `;

export const useGetEventLogPrefetchQuery = <
      TData = Types.IGetEventLogPrefetchQuery,
      TError = Types.IGqlError[]
    >(
      variables?: Types.IGetEventLogPrefetchQueryVariables,
      options?: Omit<UseQueryOptions<Types.IGetEventLogPrefetchQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<Types.IGetEventLogPrefetchQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<Types.IGetEventLogPrefetchQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['getEventLogPrefetch'] : ['getEventLogPrefetch', variables],
    queryFn: useGraphqlFetcher<Types.IGetEventLogPrefetchQuery, Types.IGetEventLogPrefetchQueryVariables>(GetEventLogPrefetchDocument).bind(null, variables),
    ...options
  }
    )};

export const GetEventLogsDocument = `
    query getEventLogs($all: String, $date: String, $userFullName: String, $userEmail: String, $organizationName: String, $eventType: String, $eventName: String, $eventMessage: String, $eventStatus: String, $offset: Int, $limit: Int, $sortBy: String) {
  getEventLogs(
    all: $all
    date: $date
    userFullName: $userFullName
    userEmail: $userEmail
    organizationName: $organizationName
    eventType: $eventType
    eventName: $eventName
    eventMessage: $eventMessage
    eventStatus: $eventStatus
    offset: $offset
    limit: $limit
    sortBy: $sortBy
  ) {
    eventLogs {
      id
      date
      userFullName
      userEmail
      organizationName
      eventStatus
      eventType
      eventName
      eventMessage
    }
    pagination {
      offset
      limit
      total
    }
  }
}
    `;

export const useGetEventLogsQuery = <
      TData = Types.IGetEventLogsQuery,
      TError = Types.IGqlError[]
    >(
      variables?: Types.IGetEventLogsQueryVariables,
      options?: Omit<UseQueryOptions<Types.IGetEventLogsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<Types.IGetEventLogsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<Types.IGetEventLogsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['getEventLogs'] : ['getEventLogs', variables],
    queryFn: useGraphqlFetcher<Types.IGetEventLogsQuery, Types.IGetEventLogsQueryVariables>(GetEventLogsDocument).bind(null, variables),
    ...options
  }
    )};

export const AllExternalAccessIdentifiersDocument = `
    query allExternalAccessIdentifiers {
  allExternalAccessIdentifiers {
    id
    name
    orderNumber
    accessPolicies {
      id
      name
      isInternalAccessPolicy
      description
      services {
        id
        name
        description
        availableCapabilities {
          id
          name
          isInternal
        }
      }
      capabilities {
        id
        name
        isInternal
      }
    }
    rules {
      name
      key
      value
      isRegex
    }
  }
}
    `;

export const useAllExternalAccessIdentifiersQuery = <
      TData = Types.IAllExternalAccessIdentifiersQuery,
      TError = Types.IGqlError[]
    >(
      variables?: Types.IAllExternalAccessIdentifiersQueryVariables,
      options?: Omit<UseQueryOptions<Types.IAllExternalAccessIdentifiersQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<Types.IAllExternalAccessIdentifiersQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<Types.IAllExternalAccessIdentifiersQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['allExternalAccessIdentifiers'] : ['allExternalAccessIdentifiers', variables],
    queryFn: useGraphqlFetcher<Types.IAllExternalAccessIdentifiersQuery, Types.IAllExternalAccessIdentifiersQueryVariables>(AllExternalAccessIdentifiersDocument).bind(null, variables),
    ...options
  }
    )};

export const CreateExternalAccessIdentifierDocument = `
    mutation createExternalAccessIdentifier($input: CreateExternalAccessIdentifierInput!) {
  createExternalAccessIdentifier(input: $input) {
    name
    id
    orderNumber
    accessPolicies {
      name
      id
    }
    rules {
      name
      key
      value
      isRegex
    }
  }
}
    `;

export const useCreateExternalAccessIdentifierMutation = <
      TError = Types.IGqlError[],
      TContext = unknown
    >(options?: UseMutationOptions<Types.ICreateExternalAccessIdentifierMutation, TError, Types.ICreateExternalAccessIdentifierMutationVariables, TContext>) => {
    
    return useMutation<Types.ICreateExternalAccessIdentifierMutation, TError, Types.ICreateExternalAccessIdentifierMutationVariables, TContext>(
      {
    mutationKey: ['createExternalAccessIdentifier'],
    mutationFn: useGraphqlFetcher<Types.ICreateExternalAccessIdentifierMutation, Types.ICreateExternalAccessIdentifierMutationVariables>(CreateExternalAccessIdentifierDocument),
    ...options
  }
    )};

export const DeleteExternalAccessIdentifierDocument = `
    mutation deleteExternalAccessIdentifier($input: DeleteExternalAccessIdentifierInput!) {
  deleteExternalAccessIdentifier(input: $input) {
    id
  }
}
    `;

export const useDeleteExternalAccessIdentifierMutation = <
      TError = Types.IGqlError[],
      TContext = unknown
    >(options?: UseMutationOptions<Types.IDeleteExternalAccessIdentifierMutation, TError, Types.IDeleteExternalAccessIdentifierMutationVariables, TContext>) => {
    
    return useMutation<Types.IDeleteExternalAccessIdentifierMutation, TError, Types.IDeleteExternalAccessIdentifierMutationVariables, TContext>(
      {
    mutationKey: ['deleteExternalAccessIdentifier'],
    mutationFn: useGraphqlFetcher<Types.IDeleteExternalAccessIdentifierMutation, Types.IDeleteExternalAccessIdentifierMutationVariables>(DeleteExternalAccessIdentifierDocument),
    ...options
  }
    )};

export const UpdateExternalAccessIdentifierDocument = `
    mutation updateExternalAccessIdentifier($input: UpdateExternalAccessIdentifierInput!) {
  updateExternalAccessIdentifier(input: $input) {
    name
    id
    orderNumber
  }
}
    `;

export const useUpdateExternalAccessIdentifierMutation = <
      TError = Types.IGqlError[],
      TContext = unknown
    >(options?: UseMutationOptions<Types.IUpdateExternalAccessIdentifierMutation, TError, Types.IUpdateExternalAccessIdentifierMutationVariables, TContext>) => {
    
    return useMutation<Types.IUpdateExternalAccessIdentifierMutation, TError, Types.IUpdateExternalAccessIdentifierMutationVariables, TContext>(
      {
    mutationKey: ['updateExternalAccessIdentifier'],
    mutationFn: useGraphqlFetcher<Types.IUpdateExternalAccessIdentifierMutation, Types.IUpdateExternalAccessIdentifierMutationVariables>(UpdateExternalAccessIdentifierDocument),
    ...options
  }
    )};

export const AllAccountTypesDocument = `
    query allAccountTypes {
  allAccountTypes {
    id
    name
  }
}
    `;

export const useAllAccountTypesQuery = <
      TData = Types.IAllAccountTypesQuery,
      TError = Types.IGqlError[]
    >(
      variables?: Types.IAllAccountTypesQueryVariables,
      options?: Omit<UseQueryOptions<Types.IAllAccountTypesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<Types.IAllAccountTypesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<Types.IAllAccountTypesQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['allAccountTypes'] : ['allAccountTypes', variables],
    queryFn: useGraphqlFetcher<Types.IAllAccountTypesQuery, Types.IAllAccountTypesQueryVariables>(AllAccountTypesDocument).bind(null, variables),
    ...options
  }
    )};

export const AllFeaturesDocument = `
    query allFeatures {
  allFeatures {
    id
    name
    isSpecialFeature
  }
}
    `;

export const useAllFeaturesQuery = <
      TData = Types.IAllFeaturesQuery,
      TError = Types.IGqlError[]
    >(
      variables?: Types.IAllFeaturesQueryVariables,
      options?: Omit<UseQueryOptions<Types.IAllFeaturesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<Types.IAllFeaturesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<Types.IAllFeaturesQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['allFeatures'] : ['allFeatures', variables],
    queryFn: useGraphqlFetcher<Types.IAllFeaturesQuery, Types.IAllFeaturesQueryVariables>(AllFeaturesDocument).bind(null, variables),
    ...options
  }
    )};

export const AllOrganizationBriefsDocument = `
    query allOrganizationBriefs {
  allOrganizationBriefs {
    organizationBriefs {
      id
      name
    }
  }
}
    `;

export const useAllOrganizationBriefsQuery = <
      TData = Types.IAllOrganizationBriefsQuery,
      TError = Types.IGqlError[]
    >(
      variables?: Types.IAllOrganizationBriefsQueryVariables,
      options?: Omit<UseQueryOptions<Types.IAllOrganizationBriefsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<Types.IAllOrganizationBriefsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<Types.IAllOrganizationBriefsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['allOrganizationBriefs'] : ['allOrganizationBriefs', variables],
    queryFn: useGraphqlFetcher<Types.IAllOrganizationBriefsQuery, Types.IAllOrganizationBriefsQueryVariables>(AllOrganizationBriefsDocument).bind(null, variables),
    ...options
  }
    )};

export const AllOrganizationDisplaysDocument = `
    query allOrganizationDisplays($all: String, $serviceIds: [String!], $queryKeyIds: [String], $offset: Int, $limit: Int, $sortBy: String) {
  allOrganizationDisplays(
    all: $all
    serviceIds: $serviceIds
    queryKeyIds: $queryKeyIds
    offset: $offset
    limit: $limit
    sortBy: $sortBy
  ) {
    organizations {
      id
      name
      parentName
      availableServiceNames
      cxid
    }
    pagination {
      offset
      limit
      total
    }
  }
}
    `;

export const useAllOrganizationDisplaysQuery = <
      TData = Types.IAllOrganizationDisplaysQuery,
      TError = Types.IGqlError[]
    >(
      variables?: Types.IAllOrganizationDisplaysQueryVariables,
      options?: Omit<UseQueryOptions<Types.IAllOrganizationDisplaysQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<Types.IAllOrganizationDisplaysQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<Types.IAllOrganizationDisplaysQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['allOrganizationDisplays'] : ['allOrganizationDisplays', variables],
    queryFn: useGraphqlFetcher<Types.IAllOrganizationDisplaysQuery, Types.IAllOrganizationDisplaysQueryVariables>(AllOrganizationDisplaysDocument).bind(null, variables),
    ...options
  }
    )};

export const AllOrganizationsDocument = `
    query allOrganizations($all: String, $serviceIds: [String!], $queryKeyIds: [String], $offset: Int, $limit: Int, $sortBy: String) {
  allOrganizations(
    all: $all
    serviceIds: $serviceIds
    queryKeyIds: $queryKeyIds
    offset: $offset
    limit: $limit
    sortBy: $sortBy
  ) {
    organizations {
      id
      name
      emailDomain
      parentId
      parentName
      supportPin
      availableServices {
        id
        name
      }
      accountType {
        id
        name
      }
      availableServices {
        id
        name
        description
        availableCapabilities {
          id
          name
        }
      }
      queryKeys {
        id
        isDefault
        name
        keyData
      }
      enterpriseSupportContacts {
        id
        name
        phoneNumber
        isPremierSupport
      }
      accountOrganizationContacts {
        id
        contactType
        firstName
        lastName
        phoneNumber
        email
      }
      features {
        id
        name
        isSpecialFeature
        isEnabled
      }
      cxid
      auditDataOrg {
        createdAt
      }
    }
    pagination {
      offset
      limit
      total
    }
  }
}
    `;

export const useAllOrganizationsQuery = <
      TData = Types.IAllOrganizationsQuery,
      TError = Types.IGqlError[]
    >(
      variables?: Types.IAllOrganizationsQueryVariables,
      options?: Omit<UseQueryOptions<Types.IAllOrganizationsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<Types.IAllOrganizationsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<Types.IAllOrganizationsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['allOrganizations'] : ['allOrganizations', variables],
    queryFn: useGraphqlFetcher<Types.IAllOrganizationsQuery, Types.IAllOrganizationsQueryVariables>(AllOrganizationsDocument).bind(null, variables),
    ...options
  }
    )};

export const AllQueryKeysDocument = `
    query allQueryKeys {
  allQueryKeys {
    id
    name
    friendlyName
    displayName
    description
  }
}
    `;

export const useAllQueryKeysQuery = <
      TData = Types.IAllQueryKeysQuery,
      TError = Types.IGqlError[]
    >(
      variables?: Types.IAllQueryKeysQueryVariables,
      options?: Omit<UseQueryOptions<Types.IAllQueryKeysQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<Types.IAllQueryKeysQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<Types.IAllQueryKeysQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['allQueryKeys'] : ['allQueryKeys', variables],
    queryFn: useGraphqlFetcher<Types.IAllQueryKeysQuery, Types.IAllQueryKeysQueryVariables>(AllQueryKeysDocument).bind(null, variables),
    ...options
  }
    )};

export const AllServicesDocument = `
    query allServices {
  allServices {
    id
    name
    description
    availableCapabilities {
      id
      name
    }
  }
}
    `;

export const useAllServicesQuery = <
      TData = Types.IAllServicesQuery,
      TError = Types.IGqlError[]
    >(
      variables?: Types.IAllServicesQueryVariables,
      options?: Omit<UseQueryOptions<Types.IAllServicesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<Types.IAllServicesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<Types.IAllServicesQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['allServices'] : ['allServices', variables],
    queryFn: useGraphqlFetcher<Types.IAllServicesQuery, Types.IAllServicesQueryVariables>(AllServicesDocument).bind(null, variables),
    ...options
  }
    )};

export const AllServicesForUserDocument = `
    query allServicesForUser {
  allServicesForUser {
    id
    name
    description
    availableCapabilities {
      id
      name
      isInternal
    }
  }
}
    `;

export const useAllServicesForUserQuery = <
      TData = Types.IAllServicesForUserQuery,
      TError = Types.IGqlError[]
    >(
      variables?: Types.IAllServicesForUserQueryVariables,
      options?: Omit<UseQueryOptions<Types.IAllServicesForUserQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<Types.IAllServicesForUserQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<Types.IAllServicesForUserQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['allServicesForUser'] : ['allServicesForUser', variables],
    queryFn: useGraphqlFetcher<Types.IAllServicesForUserQuery, Types.IAllServicesForUserQueryVariables>(AllServicesForUserDocument).bind(null, variables),
    ...options
  }
    )};

export const CreateQueryKeyOrganizationDocument = `
    mutation createQueryKeyOrganization($input: CreateQueryKeyOrganizationInput!) {
  createQueryKeyOrganization(input: $input) {
    id
    isDefault
    keyData
  }
}
    `;

export const useCreateQueryKeyOrganizationMutation = <
      TError = Types.IGqlError[],
      TContext = unknown
    >(options?: UseMutationOptions<Types.ICreateQueryKeyOrganizationMutation, TError, Types.ICreateQueryKeyOrganizationMutationVariables, TContext>) => {
    
    return useMutation<Types.ICreateQueryKeyOrganizationMutation, TError, Types.ICreateQueryKeyOrganizationMutationVariables, TContext>(
      {
    mutationKey: ['createQueryKeyOrganization'],
    mutationFn: useGraphqlFetcher<Types.ICreateQueryKeyOrganizationMutation, Types.ICreateQueryKeyOrganizationMutationVariables>(CreateQueryKeyOrganizationDocument),
    ...options
  }
    )};

export const DeleteOrgDataDocument = `
    mutation deleteOrgData($input: DeleteOrganizationInput!) {
  deleteOrgData(input: $input) {
    id
    message
  }
}
    `;

export const useDeleteOrgDataMutation = <
      TError = Types.IGqlError[],
      TContext = unknown
    >(options?: UseMutationOptions<Types.IDeleteOrgDataMutation, TError, Types.IDeleteOrgDataMutationVariables, TContext>) => {
    
    return useMutation<Types.IDeleteOrgDataMutation, TError, Types.IDeleteOrgDataMutationVariables, TContext>(
      {
    mutationKey: ['deleteOrgData'],
    mutationFn: useGraphqlFetcher<Types.IDeleteOrgDataMutation, Types.IDeleteOrgDataMutationVariables>(DeleteOrgDataDocument),
    ...options
  }
    )};

export const DeleteQueryKeyOrganizationDocument = `
    mutation deleteQueryKeyOrganization($ids: [String]!) {
  deleteQueryKeyOrganization(ids: $ids) {
    ids
  }
}
    `;

export const useDeleteQueryKeyOrganizationMutation = <
      TError = Types.IGqlError[],
      TContext = unknown
    >(options?: UseMutationOptions<Types.IDeleteQueryKeyOrganizationMutation, TError, Types.IDeleteQueryKeyOrganizationMutationVariables, TContext>) => {
    
    return useMutation<Types.IDeleteQueryKeyOrganizationMutation, TError, Types.IDeleteQueryKeyOrganizationMutationVariables, TContext>(
      {
    mutationKey: ['deleteQueryKeyOrganization'],
    mutationFn: useGraphqlFetcher<Types.IDeleteQueryKeyOrganizationMutation, Types.IDeleteQueryKeyOrganizationMutationVariables>(DeleteQueryKeyOrganizationDocument),
    ...options
  }
    )};

export const GetProgressiveDeliveryAssignmentsByOrgDocument = `
    query getProgressiveDeliveryAssignmentsByOrg($orgId: String!) {
  getProgressiveDeliveryAssignmentsByOrg(orgId: $orgId) {
    toggleName
    status
    currentPercentage
    assignedAt
  }
}
    `;

export const useGetProgressiveDeliveryAssignmentsByOrgQuery = <
      TData = Types.IGetProgressiveDeliveryAssignmentsByOrgQuery,
      TError = Types.IGqlError[]
    >(
      variables: Types.IGetProgressiveDeliveryAssignmentsByOrgQueryVariables,
      options?: Omit<UseQueryOptions<Types.IGetProgressiveDeliveryAssignmentsByOrgQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<Types.IGetProgressiveDeliveryAssignmentsByOrgQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<Types.IGetProgressiveDeliveryAssignmentsByOrgQuery, TError, TData>(
      {
    queryKey: ['getProgressiveDeliveryAssignmentsByOrg', variables],
    queryFn: useGraphqlFetcher<Types.IGetProgressiveDeliveryAssignmentsByOrgQuery, Types.IGetProgressiveDeliveryAssignmentsByOrgQueryVariables>(GetProgressiveDeliveryAssignmentsByOrgDocument).bind(null, variables),
    ...options
  }
    )};

export const GetSsoUrlDocument = `
    query getSsoUrl($input: GetSSOUrlInput!) {
  getSsoUrl(input: $input) {
    url
    message
  }
}
    `;

export const useGetSsoUrlQuery = <
      TData = Types.IGetSsoUrlQuery,
      TError = Types.IGqlError[]
    >(
      variables: Types.IGetSsoUrlQueryVariables,
      options?: Omit<UseQueryOptions<Types.IGetSsoUrlQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<Types.IGetSsoUrlQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<Types.IGetSsoUrlQuery, TError, TData>(
      {
    queryKey: ['getSsoUrl', variables],
    queryFn: useGraphqlFetcher<Types.IGetSsoUrlQuery, Types.IGetSsoUrlQueryVariables>(GetSsoUrlDocument).bind(null, variables),
    ...options
  }
    )};

export const GetVoiceMatchingAccountInfoDocument = `
    query getVoiceMatchingAccountInfo($billingAccountNumber: String) {
  getVoiceMatchingAccountInfo(billingAccountNumber: $billingAccountNumber) {
    divisionId
  }
}
    `;

export const useGetVoiceMatchingAccountInfoQuery = <
      TData = Types.IGetVoiceMatchingAccountInfoQuery,
      TError = Types.IGqlError[]
    >(
      variables?: Types.IGetVoiceMatchingAccountInfoQueryVariables,
      options?: Omit<UseQueryOptions<Types.IGetVoiceMatchingAccountInfoQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<Types.IGetVoiceMatchingAccountInfoQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<Types.IGetVoiceMatchingAccountInfoQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['getVoiceMatchingAccountInfo'] : ['getVoiceMatchingAccountInfo', variables],
    queryFn: useGraphqlFetcher<Types.IGetVoiceMatchingAccountInfoQuery, Types.IGetVoiceMatchingAccountInfoQueryVariables>(GetVoiceMatchingAccountInfoDocument).bind(null, variables),
    ...options
  }
    )};

export const OrganizationByIdDocument = `
    query organizationById($organizationId: String) {
  organizationById(organizationId: $organizationId) {
    id
    name
    emailDomain
    parentId
    parentName
    supportPin
    accountType {
      id
      name
    }
    availableServices {
      id
      name
      description
      availableCapabilities {
        id
        name
      }
    }
    queryKeys {
      id
      isDefault
      name
      keyData
      queryKeyOrganizationId
    }
    enterpriseSupportContacts {
      id
      name
      phoneNumber
      isPremierSupport
    }
    accountOrganizationContacts {
      id
      contactType
      firstName
      lastName
      phoneNumber
      email
    }
    features {
      id
      name
      isSpecialFeature
      isEnabled
    }
    cxid
    auditDataOrg {
      createdAt
    }
  }
}
    `;

export const useOrganizationByIdQuery = <
      TData = Types.IOrganizationByIdQuery,
      TError = Types.IGqlError[]
    >(
      variables?: Types.IOrganizationByIdQueryVariables,
      options?: Omit<UseQueryOptions<Types.IOrganizationByIdQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<Types.IOrganizationByIdQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<Types.IOrganizationByIdQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['organizationById'] : ['organizationById', variables],
    queryFn: useGraphqlFetcher<Types.IOrganizationByIdQuery, Types.IOrganizationByIdQueryVariables>(OrganizationByIdDocument).bind(null, variables),
    ...options
  }
    )};

export const SaveOrgDataDocument = `
    mutation saveOrgData($input: CreateOrganizationInput!) {
  saveOrgData(input: $input) {
    id
    name
    emailDomain
    parentId
    parentName
    availableServices {
      id
      name
      description
    }
    queryKeys {
      id
      isDefault
      name
      keyData
    }
  }
}
    `;

export const useSaveOrgDataMutation = <
      TError = Types.IGqlError[],
      TContext = unknown
    >(options?: UseMutationOptions<Types.ISaveOrgDataMutation, TError, Types.ISaveOrgDataMutationVariables, TContext>) => {
    
    return useMutation<Types.ISaveOrgDataMutation, TError, Types.ISaveOrgDataMutationVariables, TContext>(
      {
    mutationKey: ['saveOrgData'],
    mutationFn: useGraphqlFetcher<Types.ISaveOrgDataMutation, Types.ISaveOrgDataMutationVariables>(SaveOrgDataDocument),
    ...options
  }
    )};

export const TvpAddChannelsDocument = `
    mutation tvpAddChannels($orgId: String!, $channelInput: AddChannelRequest!) {
  addChannel(orgId: $orgId, channelInput: $channelInput) {
    data {
      frequency
      id
      maxUploads
      maxVideoBytes
      name
      s3Bucket
      s3BucketPath
      uploadCount
    }
  }
}
    `;

export const useTvpAddChannelsMutation = <
      TError = Types.IGqlError[],
      TContext = unknown
    >(options?: UseMutationOptions<Types.ITvpAddChannelsMutation, TError, Types.ITvpAddChannelsMutationVariables, TContext>) => {
    
    return useMutation<Types.ITvpAddChannelsMutation, TError, Types.ITvpAddChannelsMutationVariables, TContext>(
      {
    mutationKey: ['tvpAddChannels'],
    mutationFn: useGraphqlFetcher<Types.ITvpAddChannelsMutation, Types.ITvpAddChannelsMutationVariables>(TvpAddChannelsDocument),
    ...options
  }
    )};

export const TvpDeleteChannelDocument = `
    mutation tvpDeleteChannel($orgId: String!, $channelId: String!) {
  deleteChannel(orgId: $orgId, channelId: $channelId) {
    data
  }
}
    `;

export const useTvpDeleteChannelMutation = <
      TError = Types.IGqlError[],
      TContext = unknown
    >(options?: UseMutationOptions<Types.ITvpDeleteChannelMutation, TError, Types.ITvpDeleteChannelMutationVariables, TContext>) => {
    
    return useMutation<Types.ITvpDeleteChannelMutation, TError, Types.ITvpDeleteChannelMutationVariables, TContext>(
      {
    mutationKey: ['tvpDeleteChannel'],
    mutationFn: useGraphqlFetcher<Types.ITvpDeleteChannelMutation, Types.ITvpDeleteChannelMutationVariables>(TvpDeleteChannelDocument),
    ...options
  }
    )};

export const TvpGetChannelsDocument = `
    query tvpGetChannels($orgId: String!) {
  getChannels(orgId: $orgId) {
    data {
      frequency
      id
      maxUploads
      maxVideoBytes
      name
      s3Bucket
      s3BucketPath
      uploadCount
      mediaType
    }
  }
}
    `;

export const useTvpGetChannelsQuery = <
      TData = Types.ITvpGetChannelsQuery,
      TError = Types.IGqlError[]
    >(
      variables: Types.ITvpGetChannelsQueryVariables,
      options?: Omit<UseQueryOptions<Types.ITvpGetChannelsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<Types.ITvpGetChannelsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<Types.ITvpGetChannelsQuery, TError, TData>(
      {
    queryKey: ['tvpGetChannels', variables],
    queryFn: useGraphqlFetcher<Types.ITvpGetChannelsQuery, Types.ITvpGetChannelsQueryVariables>(TvpGetChannelsDocument).bind(null, variables),
    ...options
  }
    )};

export const TvpUpdateChannelsDocument = `
    mutation tvpUpdateChannels($orgId: String!, $channelInput: UpdateChannelRequest!) {
  updateChannel(orgId: $orgId, channelInput: $channelInput) {
    data {
      frequency
      id
      maxUploads
      maxVideoBytes
      name
      s3Bucket
      s3BucketPath
      uploadCount
    }
  }
}
    `;

export const useTvpUpdateChannelsMutation = <
      TError = Types.IGqlError[],
      TContext = unknown
    >(options?: UseMutationOptions<Types.ITvpUpdateChannelsMutation, TError, Types.ITvpUpdateChannelsMutationVariables, TContext>) => {
    
    return useMutation<Types.ITvpUpdateChannelsMutation, TError, Types.ITvpUpdateChannelsMutationVariables, TContext>(
      {
    mutationKey: ['tvpUpdateChannels'],
    mutationFn: useGraphqlFetcher<Types.ITvpUpdateChannelsMutation, Types.ITvpUpdateChannelsMutationVariables>(TvpUpdateChannelsDocument),
    ...options
  }
    )};

export const UpdateOrgDataDocument = `
    mutation updateOrgData($input: UpdateOrganizationInput!) {
  updateOrgData(input: $input) {
    id
    name
    emailDomain
    parentId
    parentName
    availableServices {
      id
      name
      description
    }
    queryKeys {
      id
      isDefault
      name
      keyData
    }
  }
}
    `;

export const useUpdateOrgDataMutation = <
      TError = Types.IGqlError[],
      TContext = unknown
    >(options?: UseMutationOptions<Types.IUpdateOrgDataMutation, TError, Types.IUpdateOrgDataMutationVariables, TContext>) => {
    
    return useMutation<Types.IUpdateOrgDataMutation, TError, Types.IUpdateOrgDataMutationVariables, TContext>(
      {
    mutationKey: ['updateOrgData'],
    mutationFn: useGraphqlFetcher<Types.IUpdateOrgDataMutation, Types.IUpdateOrgDataMutationVariables>(UpdateOrgDataDocument),
    ...options
  }
    )};

export const UpdateQueryKeyOrganizationDocument = `
    mutation updateQueryKeyOrganization($input: UpdateQueryKeyOrganizationInput!) {
  updateQueryKeyOrganization(input: $input) {
    id
    isDefault
    keyData
  }
}
    `;

export const useUpdateQueryKeyOrganizationMutation = <
      TError = Types.IGqlError[],
      TContext = unknown
    >(options?: UseMutationOptions<Types.IUpdateQueryKeyOrganizationMutation, TError, Types.IUpdateQueryKeyOrganizationMutationVariables, TContext>) => {
    
    return useMutation<Types.IUpdateQueryKeyOrganizationMutation, TError, Types.IUpdateQueryKeyOrganizationMutationVariables, TContext>(
      {
    mutationKey: ['updateQueryKeyOrganization'],
    mutationFn: useGraphqlFetcher<Types.IUpdateQueryKeyOrganizationMutation, Types.IUpdateQueryKeyOrganizationMutationVariables>(UpdateQueryKeyOrganizationDocument),
    ...options
  }
    )};

export const AllAccessPoliciesForOrganizationDocument = `
    query allAccessPoliciesForOrganization($organizationId: String) {
  allAccessPoliciesForOrganization(organizationId: $organizationId) {
    id
    name
    isInternalAccessPolicy
    description
    services {
      id
      name
      description
      availableCapabilities {
        id
        name
      }
    }
    capabilities {
      id
      name
    }
  }
}
    `;

export const useAllAccessPoliciesForOrganizationQuery = <
      TData = Types.IAllAccessPoliciesForOrganizationQuery,
      TError = Types.IGqlError[]
    >(
      variables?: Types.IAllAccessPoliciesForOrganizationQueryVariables,
      options?: Omit<UseQueryOptions<Types.IAllAccessPoliciesForOrganizationQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<Types.IAllAccessPoliciesForOrganizationQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<Types.IAllAccessPoliciesForOrganizationQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['allAccessPoliciesForOrganization'] : ['allAccessPoliciesForOrganization', variables],
    queryFn: useGraphqlFetcher<Types.IAllAccessPoliciesForOrganizationQuery, Types.IAllAccessPoliciesForOrganizationQueryVariables>(AllAccessPoliciesForOrganizationDocument).bind(null, variables),
    ...options
  }
    )};

export const AllAccessPoliciesForUserDocument = `
    query allAccessPoliciesForUser {
  allAccessPoliciesForUser {
    id
    name
    isInternalAccessPolicy
    description
    services {
      id
      name
      description
      availableCapabilities {
        id
        name
      }
    }
    capabilities {
      id
      name
      isInternal
    }
  }
}
    `;

export const useAllAccessPoliciesForUserQuery = <
      TData = Types.IAllAccessPoliciesForUserQuery,
      TError = Types.IGqlError[]
    >(
      variables?: Types.IAllAccessPoliciesForUserQueryVariables,
      options?: Omit<UseQueryOptions<Types.IAllAccessPoliciesForUserQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<Types.IAllAccessPoliciesForUserQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<Types.IAllAccessPoliciesForUserQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['allAccessPoliciesForUser'] : ['allAccessPoliciesForUser', variables],
    queryFn: useGraphqlFetcher<Types.IAllAccessPoliciesForUserQuery, Types.IAllAccessPoliciesForUserQueryVariables>(AllAccessPoliciesForUserDocument).bind(null, variables),
    ...options
  }
    )};

export const CreateAccessPolicyDocument = `
    mutation createAccessPolicy($input: CreateAccessPolicyInput!) {
  createAccessPolicy(input: $input) {
    id
    name
    isInternalAccessPolicy
    description
    services {
      id
      name
      description
      availableCapabilities {
        id
        name
      }
    }
    capabilities {
      id
      name
    }
  }
}
    `;

export const useCreateAccessPolicyMutation = <
      TError = Types.IGqlError[],
      TContext = unknown
    >(options?: UseMutationOptions<Types.ICreateAccessPolicyMutation, TError, Types.ICreateAccessPolicyMutationVariables, TContext>) => {
    
    return useMutation<Types.ICreateAccessPolicyMutation, TError, Types.ICreateAccessPolicyMutationVariables, TContext>(
      {
    mutationKey: ['createAccessPolicy'],
    mutationFn: useGraphqlFetcher<Types.ICreateAccessPolicyMutation, Types.ICreateAccessPolicyMutationVariables>(CreateAccessPolicyDocument),
    ...options
  }
    )};

export const DeleteAccessPolicyDocument = `
    mutation DeleteAccessPolicy($input: DeleteAccessPolicyInput!) {
  deleteAccessPolicy(input: $input) {
    id
    name
    isInternalAccessPolicy
  }
}
    `;

export const useDeleteAccessPolicyMutation = <
      TError = Types.IGqlError[],
      TContext = unknown
    >(options?: UseMutationOptions<Types.IDeleteAccessPolicyMutation, TError, Types.IDeleteAccessPolicyMutationVariables, TContext>) => {
    
    return useMutation<Types.IDeleteAccessPolicyMutation, TError, Types.IDeleteAccessPolicyMutationVariables, TContext>(
      {
    mutationKey: ['DeleteAccessPolicy'],
    mutationFn: useGraphqlFetcher<Types.IDeleteAccessPolicyMutation, Types.IDeleteAccessPolicyMutationVariables>(DeleteAccessPolicyDocument),
    ...options
  }
    )};

export const UpdateAccessPolicyDataDocument = `
    mutation updateAccessPolicyData($input: UpdateAccessPolicyInput!) {
  updateAccessPolicyData(input: $input) {
    id
    name
    isInternalAccessPolicy
    description
    services {
      id
      name
      description
      availableCapabilities {
        id
        name
      }
    }
    capabilities {
      id
      name
    }
  }
}
    `;

export const useUpdateAccessPolicyDataMutation = <
      TError = Types.IGqlError[],
      TContext = unknown
    >(options?: UseMutationOptions<Types.IUpdateAccessPolicyDataMutation, TError, Types.IUpdateAccessPolicyDataMutationVariables, TContext>) => {
    
    return useMutation<Types.IUpdateAccessPolicyDataMutation, TError, Types.IUpdateAccessPolicyDataMutationVariables, TContext>(
      {
    mutationKey: ['updateAccessPolicyData'],
    mutationFn: useGraphqlFetcher<Types.IUpdateAccessPolicyDataMutation, Types.IUpdateAccessPolicyDataMutationVariables>(UpdateAccessPolicyDataDocument),
    ...options
  }
    )};

export const AllCapabilitiesForUserDocument = `
    query allCapabilitiesForUser {
  allCapabilitiesForUser {
    userId
    isInternalUser
    capabilities {
      name
      id
    }
  }
}
    `;

export const useAllCapabilitiesForUserQuery = <
      TData = Types.IAllCapabilitiesForUserQuery,
      TError = Types.IGqlError[]
    >(
      variables?: Types.IAllCapabilitiesForUserQueryVariables,
      options?: Omit<UseQueryOptions<Types.IAllCapabilitiesForUserQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<Types.IAllCapabilitiesForUserQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<Types.IAllCapabilitiesForUserQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['allCapabilitiesForUser'] : ['allCapabilitiesForUser', variables],
    queryFn: useGraphqlFetcher<Types.IAllCapabilitiesForUserQuery, Types.IAllCapabilitiesForUserQueryVariables>(AllCapabilitiesForUserDocument).bind(null, variables),
    ...options
  }
    )};

export const AllUsersDocument = `
    query allUsers($all: String, $firstName: String, $lastName: String, $email: String, $phoneNumber: String, $isInternalUser: Boolean, $organizationIds: [String], $accessPolicyIds: [String], $offset: Int, $limit: Int, $sortBy: String, $status: String) {
  allUsers(
    all: $all
    firstName: $firstName
    lastName: $lastName
    email: $email
    phoneNumber: $phoneNumber
    isInternalUser: $isInternalUser
    organizationIds: $organizationIds
    accessPolicyIds: $accessPolicyIds
    offset: $offset
    limit: $limit
    sortBy: $sortBy
    status: $status
  ) {
    users {
      id
      firstName
      lastName
      title
      email
      phone
      pid
      isInternalUser
      status
      organizationIds
      accessPolicyIds
    }
    pagination {
      offset
      limit
      total
    }
  }
}
    `;

export const useAllUsersQuery = <
      TData = Types.IAllUsersQuery,
      TError = Types.IGqlError[]
    >(
      variables?: Types.IAllUsersQueryVariables,
      options?: Omit<UseQueryOptions<Types.IAllUsersQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<Types.IAllUsersQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<Types.IAllUsersQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['allUsers'] : ['allUsers', variables],
    queryFn: useGraphqlFetcher<Types.IAllUsersQuery, Types.IAllUsersQueryVariables>(AllUsersDocument).bind(null, variables),
    ...options
  }
    )};

export const DeleteUsersDataDocument = `
    mutation DeleteUsersData($input: DeleteUsersInput!) {
  deleteUsersData(input: $input) {
    id
    firstName
    lastName
  }
}
    `;

export const useDeleteUsersDataMutation = <
      TError = Types.IGqlError[],
      TContext = unknown
    >(options?: UseMutationOptions<Types.IDeleteUsersDataMutation, TError, Types.IDeleteUsersDataMutationVariables, TContext>) => {
    
    return useMutation<Types.IDeleteUsersDataMutation, TError, Types.IDeleteUsersDataMutationVariables, TContext>(
      {
    mutationKey: ['DeleteUsersData'],
    mutationFn: useGraphqlFetcher<Types.IDeleteUsersDataMutation, Types.IDeleteUsersDataMutationVariables>(DeleteUsersDataDocument),
    ...options
  }
    )};

export const PamSotAllUsersDocument = `
    query pamSotAllUsers($portalAccountGUID: String!, $all: String, $firstName: String, $lastName: String, $email: String, $phoneNumber: String, $isInternalUser: Boolean, $organizationIds: [String], $accessPolicyIds: [String], $offset: Int, $limit: Int, $sortBy: String, $status: String) {
  user(portalAccountGUID: $portalAccountGUID, getDataFromCache: false) {
    organization {
      users {
        allUsers(
          all: $all
          firstName: $firstName
          lastName: $lastName
          email: $email
          phoneNumber: $phoneNumber
          isInternalUser: $isInternalUser
          organizationIds: $organizationIds
          accessPolicyIds: $accessPolicyIds
          offset: $offset
          limit: $limit
          sortBy: $sortBy
          status: $status
        ) {
          pagination {
            limit
            offset
            total
          }
          users {
            accessPolicyIds
            department
            division
            email
            firstName
            id
            isInternalUser
            isSyncManaged
            lastName
            manager
            organizationIds
            permissionLevel
            permissionSetId
            phone
            pid
            status
            title
            auditData {
              createdAt
              createdBy
              registeredAt
              registrationEmailSentAt
              registrationExpirationTimestamp
              updatedAt
              updatedBy
            }
            authzAccounts {
              accountId
              createdAt
              createdBy
              effectiveAt
              id
              status
              updatedAt
              updatedBy
              userId
            }
            logins {
              firstLogin
              id
              lastLogin
              platform
            }
            permissionSet {
              id
              isInternal
              name
            }
          }
        }
      }
    }
  }
}
    `;

export const usePamSotAllUsersQuery = <
      TData = Types.IPamSotAllUsersQuery,
      TError = Types.IGqlError[]
    >(
      variables: Types.IPamSotAllUsersQueryVariables,
      options?: Omit<UseQueryOptions<Types.IPamSotAllUsersQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<Types.IPamSotAllUsersQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<Types.IPamSotAllUsersQuery, TError, TData>(
      {
    queryKey: ['pamSotAllUsers', variables],
    queryFn: useGraphqlFetcher<Types.IPamSotAllUsersQuery, Types.IPamSotAllUsersQueryVariables>(PamSotAllUsersDocument).bind(null, variables),
    ...options
  }
    )};

export const PamSotPermissionSetTemplatesDocument = `
    query pamSotPermissionSetTemplates($portalAccountGUID: String!) {
  user(portalAccountGUID: $portalAccountGUID, getDataFromCache: false) {
    organization {
      users {
        permissionSetTemplates {
          id
          isInternal
          permissionSetId
          status
          version
          permissionSet {
            id
            isInternal
            name
          }
          accessPolicies {
            accessPolicyId
            accessPolicyDescription
            accessLevel
            displayMode
            displayType
            id
            isAdminOnly
            isExtended
            permissionGroupId
            permissionGroupName
          }
        }
      }
    }
  }
}
    `;

export const usePamSotPermissionSetTemplatesQuery = <
      TData = Types.IPamSotPermissionSetTemplatesQuery,
      TError = Types.IGqlError[]
    >(
      variables: Types.IPamSotPermissionSetTemplatesQueryVariables,
      options?: Omit<UseQueryOptions<Types.IPamSotPermissionSetTemplatesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<Types.IPamSotPermissionSetTemplatesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<Types.IPamSotPermissionSetTemplatesQuery, TError, TData>(
      {
    queryKey: ['pamSotPermissionSetTemplates', variables],
    queryFn: useGraphqlFetcher<Types.IPamSotPermissionSetTemplatesQuery, Types.IPamSotPermissionSetTemplatesQueryVariables>(PamSotPermissionSetTemplatesDocument).bind(null, variables),
    ...options
  }
    )};

export const PamSotPermissionSetsDocument = `
    query pamSotPermissionSets($portalAccountGUID: String!) {
  user(portalAccountGUID: $portalAccountGUID, getDataFromCache: false) {
    organization {
      users {
        permissionSets {
          id
          isInternal
          name
        }
      }
    }
  }
}
    `;

export const usePamSotPermissionSetsQuery = <
      TData = Types.IPamSotPermissionSetsQuery,
      TError = Types.IGqlError[]
    >(
      variables: Types.IPamSotPermissionSetsQueryVariables,
      options?: Omit<UseQueryOptions<Types.IPamSotPermissionSetsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<Types.IPamSotPermissionSetsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<Types.IPamSotPermissionSetsQuery, TError, TData>(
      {
    queryKey: ['pamSotPermissionSets', variables],
    queryFn: useGraphqlFetcher<Types.IPamSotPermissionSetsQuery, Types.IPamSotPermissionSetsQueryVariables>(PamSotPermissionSetsDocument).bind(null, variables),
    ...options
  }
    )};

export const PamSotUserAccountsDocument = `
    query pamSotUserAccounts($portalAccountGUID: String!, $userId: String) {
  user(portalAccountGUID: $portalAccountGUID, getDataFromCache: false) {
    organization {
      users {
        userAccounts(userId: $userId) {
          billingAccountNumber
          serviceLocationCount
          userCount
          users {
            name
            email
            phone
            pid
            permissionSetId
            permissionSetName
          }
          serviceLocations {
            serviceAccount
            services
            address {
              friendlyName
              street
              city
              state
              zip
            }
          }
        }
      }
    }
  }
}
    `;

export const usePamSotUserAccountsQuery = <
      TData = Types.IPamSotUserAccountsQuery,
      TError = Types.IGqlError[]
    >(
      variables: Types.IPamSotUserAccountsQueryVariables,
      options?: Omit<UseQueryOptions<Types.IPamSotUserAccountsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<Types.IPamSotUserAccountsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<Types.IPamSotUserAccountsQuery, TError, TData>(
      {
    queryKey: ['pamSotUserAccounts', variables],
    queryFn: useGraphqlFetcher<Types.IPamSotUserAccountsQuery, Types.IPamSotUserAccountsQueryVariables>(PamSotUserAccountsDocument).bind(null, variables),
    ...options
  }
    )};

export const PamSotUserByIdDocument = `
    query pamSotUserById($portalAccountGUID: String!, $idOrPID: String) {
  user(portalAccountGUID: $portalAccountGUID, getDataFromCache: false) {
    organization {
      users {
        userById(idOrPID: $idOrPID) {
          accessPolicyIds
          department
          division
          email
          firstName
          id
          isInternalUser
          isSyncManaged
          lastName
          manager
          organizationIds
          permissionLevel
          permissionSetId
          phone
          pid
          status
          title
          auditData {
            createdAt
            createdBy
            registeredAt
            registrationEmailSentAt
            registrationExpirationTimestamp
            updatedAt
            updatedBy
          }
          authzAccounts {
            accountId
            createdAt
            createdBy
            effectiveAt
            id
            status
            updatedAt
            updatedBy
            userId
          }
          idpData {
            idpId
            idpName
          }
          logins {
            firstLogin
            id
            lastLogin
            platform
          }
          permissionGroups {
            accessPolicyId
            accessLevel
            descriptionList {
              label
              accessPolicyDescription
            }
            displayOrder
            isAdminOnly
            isExtended
            permissionGroupId
            permissionGroupName
          }
          permissionSet {
            id
            isInternal
            name
          }
        }
      }
    }
  }
}
    `;

export const usePamSotUserByIdQuery = <
      TData = Types.IPamSotUserByIdQuery,
      TError = Types.IGqlError[]
    >(
      variables: Types.IPamSotUserByIdQueryVariables,
      options?: Omit<UseQueryOptions<Types.IPamSotUserByIdQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<Types.IPamSotUserByIdQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<Types.IPamSotUserByIdQuery, TError, TData>(
      {
    queryKey: ['pamSotUserById', variables],
    queryFn: useGraphqlFetcher<Types.IPamSotUserByIdQuery, Types.IPamSotUserByIdQueryVariables>(PamSotUserByIdDocument).bind(null, variables),
    ...options
  }
    )};

export const SaveUserDataDocument = `
    mutation saveUserData($input: CreateUserInput!) {
  saveUserData(input: $input) {
    id
    firstName
    lastName
    email
    phone
    pid
    isInternalUser
    organizationIds
    accessPolicyIds
    permissionSetId
    permissionSet {
      id
      name
    }
  }
}
    `;

export const useSaveUserDataMutation = <
      TError = Types.IGqlError[],
      TContext = unknown
    >(options?: UseMutationOptions<Types.ISaveUserDataMutation, TError, Types.ISaveUserDataMutationVariables, TContext>) => {
    
    return useMutation<Types.ISaveUserDataMutation, TError, Types.ISaveUserDataMutationVariables, TContext>(
      {
    mutationKey: ['saveUserData'],
    mutationFn: useGraphqlFetcher<Types.ISaveUserDataMutation, Types.ISaveUserDataMutationVariables>(SaveUserDataDocument),
    ...options
  }
    )};

export const SaveUserDataV2Document = `
    mutation saveUserDataV2($input: CreateUserInput!) {
  saveUserDataV2(input: $input) {
    id
    firstName
    lastName
    email
    phone
    pid
    isInternalUser
    organizationIds
    accessPolicyIds
    authorizedAccountIds
    hasAllAccountsAuthz
    permissionSetId
    permissionSet {
      id
      name
    }
  }
}
    `;

export const useSaveUserDataV2Mutation = <
      TError = Types.IGqlError[],
      TContext = unknown
    >(options?: UseMutationOptions<Types.ISaveUserDataV2Mutation, TError, Types.ISaveUserDataV2MutationVariables, TContext>) => {
    
    return useMutation<Types.ISaveUserDataV2Mutation, TError, Types.ISaveUserDataV2MutationVariables, TContext>(
      {
    mutationKey: ['saveUserDataV2'],
    mutationFn: useGraphqlFetcher<Types.ISaveUserDataV2Mutation, Types.ISaveUserDataV2MutationVariables>(SaveUserDataV2Document),
    ...options
  }
    )};

export const SelfDocument = `
    query self {
  self {
    id
    firstName
    lastName
    email
    phone
    pid
    isInternalUser
    registrationDuration
  }
}
    `;

export const useSelfQuery = <
      TData = Types.ISelfQuery,
      TError = Types.IGqlError[]
    >(
      variables?: Types.ISelfQueryVariables,
      options?: Omit<UseQueryOptions<Types.ISelfQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<Types.ISelfQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<Types.ISelfQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['self'] : ['self', variables],
    queryFn: useGraphqlFetcher<Types.ISelfQuery, Types.ISelfQueryVariables>(SelfDocument).bind(null, variables),
    ...options
  }
    )};

export const SendRegistrationEmailDocument = `
    query sendRegistrationEmail($userId: String, $disableAutomatedEmail: Boolean) {
  sendRegistrationEmail(
    userId: $userId
    disableAutomatedEmail: $disableAutomatedEmail
  ) {
    content
    smtpResponse
    token
  }
}
    `;

export const useSendRegistrationEmailQuery = <
      TData = Types.ISendRegistrationEmailQuery,
      TError = Types.IGqlError[]
    >(
      variables?: Types.ISendRegistrationEmailQueryVariables,
      options?: Omit<UseQueryOptions<Types.ISendRegistrationEmailQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<Types.ISendRegistrationEmailQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<Types.ISendRegistrationEmailQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['sendRegistrationEmail'] : ['sendRegistrationEmail', variables],
    queryFn: useGraphqlFetcher<Types.ISendRegistrationEmailQuery, Types.ISendRegistrationEmailQueryVariables>(SendRegistrationEmailDocument).bind(null, variables),
    ...options
  }
    )};

export const TransferSuperAdminDocument = `
    mutation transferSuperAdmin($targetUserId: String!) {
  transferSuperAdmin(targetUserId: $targetUserId)
}
    `;

export const useTransferSuperAdminMutation = <
      TError = Types.IGqlError[],
      TContext = unknown
    >(options?: UseMutationOptions<Types.ITransferSuperAdminMutation, TError, Types.ITransferSuperAdminMutationVariables, TContext>) => {
    
    return useMutation<Types.ITransferSuperAdminMutation, TError, Types.ITransferSuperAdminMutationVariables, TContext>(
      {
    mutationKey: ['transferSuperAdmin'],
    mutationFn: useGraphqlFetcher<Types.ITransferSuperAdminMutation, Types.ITransferSuperAdminMutationVariables>(TransferSuperAdminDocument),
    ...options
  }
    )};

export const UpdateUserDataDocument = `
    mutation updateUserData($input: UpdateUserInput!) {
  updateUserData(input: $input) {
    id
    firstName
    lastName
    email
    phone
    pid
    isInternalUser
    organizationIds
    accessPolicyIds
    permissionSetId
    permissionSet {
      id
      name
    }
    title
  }
}
    `;

export const useUpdateUserDataMutation = <
      TError = Types.IGqlError[],
      TContext = unknown
    >(options?: UseMutationOptions<Types.IUpdateUserDataMutation, TError, Types.IUpdateUserDataMutationVariables, TContext>) => {
    
    return useMutation<Types.IUpdateUserDataMutation, TError, Types.IUpdateUserDataMutationVariables, TContext>(
      {
    mutationKey: ['updateUserData'],
    mutationFn: useGraphqlFetcher<Types.IUpdateUserDataMutation, Types.IUpdateUserDataMutationVariables>(UpdateUserDataDocument),
    ...options
  }
    )};

export const UpdateUserDataV2Document = `
    mutation updateUserDataV2($input: UpdateUserInput!) {
  updateUserDataV2(input: $input) {
    id
    firstName
    lastName
    email
    phone
    pid
    isInternalUser
    organizationIds
    accessPolicyIds
    authorizedAccountIds
    hasAllAccountsAuthz
    permissionSetId
    permissionSet {
      id
      name
    }
    title
  }
}
    `;

export const useUpdateUserDataV2Mutation = <
      TError = Types.IGqlError[],
      TContext = unknown
    >(options?: UseMutationOptions<Types.IUpdateUserDataV2Mutation, TError, Types.IUpdateUserDataV2MutationVariables, TContext>) => {
    
    return useMutation<Types.IUpdateUserDataV2Mutation, TError, Types.IUpdateUserDataV2MutationVariables, TContext>(
      {
    mutationKey: ['updateUserDataV2'],
    mutationFn: useGraphqlFetcher<Types.IUpdateUserDataV2Mutation, Types.IUpdateUserDataV2MutationVariables>(UpdateUserDataV2Document),
    ...options
  }
    )};

export const UserByIdDocument = `
    query userById($idOrPID: String) {
  userById(idOrPID: $idOrPID) {
    id
    firstName
    lastName
    email
    pid
    phone
    isInternalUser
    accessPolicyIds
    organizationIds
    isSyncManaged
    status
    title
    division
    department
    manager
    auditData {
      createdAt
      registrationEmailSentAt
      registeredAt
      registrationExpirationTimestamp
    }
  }
}
    `;

export const useUserByIdQuery = <
      TData = Types.IUserByIdQuery,
      TError = Types.IGqlError[]
    >(
      variables?: Types.IUserByIdQueryVariables,
      options?: Omit<UseQueryOptions<Types.IUserByIdQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<Types.IUserByIdQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<Types.IUserByIdQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['userById'] : ['userById', variables],
    queryFn: useGraphqlFetcher<Types.IUserByIdQuery, Types.IUserByIdQueryVariables>(UserByIdDocument).bind(null, variables),
    ...options
  }
    )};

export const SendUserInvitationDocument = `
    mutation sendUserInvitation($input: CreateKafkaUserInput!) {
  sendUserInvitation(input: $input) {
    email
    status
    template
    registrationEmailSentAt
    registrationExpirationAt
  }
}
    `;

export const useSendUserInvitationMutation = <
      TError = Types.IGqlError[],
      TContext = unknown
    >(options?: UseMutationOptions<Types.ISendUserInvitationMutation, TError, Types.ISendUserInvitationMutationVariables, TContext>) => {
    
    return useMutation<Types.ISendUserInvitationMutation, TError, Types.ISendUserInvitationMutationVariables, TContext>(
      {
    mutationKey: ['sendUserInvitation'],
    mutationFn: useGraphqlFetcher<Types.ISendUserInvitationMutation, Types.ISendUserInvitationMutationVariables>(SendUserInvitationDocument),
    ...options
  }
    )};

export const UserInvitationNextDocument = `
    mutation userInvitationNext($input: CreateKafkaUserInput!) {
  userInvitationNext(input: $input) {
    email
    status
    template
    registrationEmailSentAt
    registrationExpirationAt
  }
}
    `;

export const useUserInvitationNextMutation = <
      TError = Types.IGqlError[],
      TContext = unknown
    >(options?: UseMutationOptions<Types.IUserInvitationNextMutation, TError, Types.IUserInvitationNextMutationVariables, TContext>) => {
    
    return useMutation<Types.IUserInvitationNextMutation, TError, Types.IUserInvitationNextMutationVariables, TContext>(
      {
    mutationKey: ['userInvitationNext'],
    mutationFn: useGraphqlFetcher<Types.IUserInvitationNextMutation, Types.IUserInvitationNextMutationVariables>(UserInvitationNextDocument),
    ...options
  }
    )};

export const UserNotificationPreferencesByUserIdDocument = `
    query userNotificationPreferencesByUserId($userId: String) {
  userNotificationPreferencesByUserId(userId: $userId) {
    statementReady {
      totalAccounts
      activeAccounts
      notificationAccounts {
        accountNumber
        divisionId
        isActive
        statementCode
      }
    }
    paperlessBilling {
      totalAccounts
      activeAccounts
      paperlessAccounts {
        accountNumber
        divisionId
        isActive
        statementCode
      }
    }
  }
}
    `;

export const useUserNotificationPreferencesByUserIdQuery = <
      TData = Types.IUserNotificationPreferencesByUserIdQuery,
      TError = Types.IGqlError[]
    >(
      variables?: Types.IUserNotificationPreferencesByUserIdQueryVariables,
      options?: Omit<UseQueryOptions<Types.IUserNotificationPreferencesByUserIdQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<Types.IUserNotificationPreferencesByUserIdQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<Types.IUserNotificationPreferencesByUserIdQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['userNotificationPreferencesByUserId'] : ['userNotificationPreferencesByUserId', variables],
    queryFn: useGraphqlFetcher<Types.IUserNotificationPreferencesByUserIdQuery, Types.IUserNotificationPreferencesByUserIdQueryVariables>(UserNotificationPreferencesByUserIdDocument).bind(null, variables),
    ...options
  }
    )};
